import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/logo_grey.png';
import _imports_1 from '@/assets/imgs/qrcode.png';
var _hoisted_1 = {
  class: "m-footer"
};
var _hoisted_2 = {
  class: "sec-content container"
};
var _hoisted_3 = {
  class: "rows"
};
var _hoisted_4 = {
  class: "items"
};
var _hoisted_5 = {
  class: "items"
};
var _hoisted_6 = {
  class: "items"
};
var _hoisted_7 = {
  class: "items"
};
var _hoisted_8 = {
  class: "bottom"
};
export function render(_ctx, _cache) {
  var _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, [_cache[0] || (_cache[0] = _createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: "misun 米山科技"
  }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t('companyName_short')), 1)]), _createElementVNode("p", null, _toDisplayString(_ctx.$t('span_address')) + "：" + _toDisplayString(_ctx.$t('address')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('telephone')) + "：0523-86868006", 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('span_mobile')) + "：+86 13962272320/13382592210", 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('span_email')) + "：eric.tang@misun-tech.com", 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('title_products')), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/products/pet-nonwoven-fabric"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('prod07_name')), 1)];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/products"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('prod01_name')), 1)];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/products"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('prod02_name')), 1)];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/products"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('prod03_name')), 1)];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/products"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('prod04_name')), 1)];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/products"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('prod05_name')), 1)];
    }),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('span_campany')), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/about"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('nav_about')), 1)];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/news"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('nav_campany_news')), 1)];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/contact"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('nav_contact')), 1)];
    }),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('quick_link')), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "qrcodebox"
  }, [_createElementVNode("img", {
    class: "qrcode",
    src: _imports_1,
    alt: "misun 米山科技"
  })], -1))])]), _createElementVNode("p", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('companyName')) + " / " + _toDisplayString(_ctx.$t('companyName2')), 1), _cache[2] || (_cache[2] = _createElementVNode("span", {
    class: "txt2"
  }, "Copyright ©2026 - MISUN-TECH.COM All Rights Reserved", -1)), _cache[3] || (_cache[3] = _createElementVNode("span", null, [_createElementVNode("a", {
    href: "https://beian.miit.gov.cn/",
    rel: "nofollow",
    target: "_blank"
  }, "苏ICP备18036856号")], -1))])])]);
}